import React, { Component } from 'react'
import _ from 'lodash'
import List from './List'
import axios from 'axios'
import { Spinner } from 'material-ui-elements'
import core from '../../core/'
import qs from 'query-string'
import { PATH } from '../constants'

const { constants: { API_URL }, helpers: { getUserByEmail, auth } } = core

class Container extends Component {
  state = {}

  async fetchToState() {
    // const { data } = await axios.get(`${API_URL}${PATH}`)
    let queryString = {}
    const profile = await getUserByEmail()

    if (profile.role === 'admin') queryString.role = 'user'
    const { data } = await axios.get(
      `${API_URL}${PATH}${
        queryString.role //||
          ? // queryString.status ||
            // queryString.type ||
            // queryString['audit.createdBy']
            `?${qs.stringify(queryString)}`
          : ''
      }`,
      {
        headers: { authorization: auth(true) }
      }
    )

    this.setState({
      data: { ..._.omitBy(data, { email: profile.email }) },
      profile: profile
    })
  }

  componentWillMount() {
    this.fetchToState()
  }

  componentWillReceiveProps() {
    this.fetchToState()
  }

  render() {
    const { data } = this.state
    if (!data) return <Spinner />
    return <List {...this.state} {...this.props} />
  }
}

export default Container



// WEBPACK FOOTER //
// ./src/users/components/Container.js